import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import config from "config";
import { v4 as uuidv4 } from "uuid";
import queryString from "query-string";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const fileUploadFailed = async ({
  uploadId,
  file,
  error,
  setUploadedFiles,
}) => {
  const body = getDetailsBodyRequest({ file, uploadId, error });
  await apiRequest("mails", "FileUploadFailedReactHomePage", body, "POST");
  // if (res.status === "success") {
  // setUploadedFiles((prev) => [...prev, file.name]);
  // }
  // adding file name to uploadedFiles array even if server request failed
  setUploadedFiles((prev) => [...prev, file.name]);
};

// export const retryRecord = async ({ uploadId, file, error }) => {
//   const body = getDetailsBodyRequest({ file, uploadId, error });
//   await apiRequest("mails", "ReactFileUploadRetry", body, "POST");
// };

export const checkUploadLimit = async ({
  totalSize,
  uploadId,
  modalHandler,
  mailId,
}) => {
  const res = await apiRequest(
    "Mails",
    mailId
      ? "ReactGetUploadLimitWithSizeByMail"
      : "ReactGetUploadLimitWithSize",
    {
      [mailId ? "encrpytedMailId" : "uploadId"]: mailId ? mailId : uploadId,
      totalSize: totalSize,
    }
  );

  if (res.status === "success") {
    if (totalSize > res.data.size) {
      modalHandler({ isSaved: res.data.isSaved });
      return { status: "error", data: "max-allowed-size-reached" };
    } else {
      return res;
    }
  }
};

export const hugeFileUploadDetails = async ({ file, uploadId }) => {
  const body = getDetailsBodyRequest({ file, uploadId });
  await apiRequest("mails", "CreateFileDetailsReactHomePage", body, "POST");
};

// export const errorHandler = async ({ uploadId, errorMessage }) => {
//   await apiRequest(
//     "mails",
//     "ReactUpdateMailUploadError",
//     {
//       EncryptedMailId: uploadId,
//       errorMessage: errorMessage,
//     },
//     "POST"
//   );
// };

export const fileUploadCompleteHandler = async ({
  file = { meta: {}, s3Multipart: {} },
  uploadId,
  setUploadedFiles,
}) => {
  const folderName = getFolderNameFromPath(file);

  await apiRequest(
    "Mails",
    "ReactFileUploadCompleteHomePage",
    {
      fileId: file.id,
      uploadId: uploadId,
      size: file.size,
      folderId: 0,
      qqpath:
        folderName?.length > 0
          ? file.meta.relativePath
              .split(file.meta.name)[0]
              .replaceAll("\\\\", "\\")
          : "",
      key: `files/${uploadId}/${file.meta.encryptedFileName}`,
      name: file.meta.name,
      bucket: config.api.bucket,
    },
    "POST"
  );

  setUploadedFiles((prev) => [...prev, file.name]);
};

export const getFolderNameFromPath = (file) => {
  if (!file.meta?.relativePath) {
    return null;
  }
  const folderPath = file.meta.relativePath.split("\\\\" + file.name)[0];
  const lastIndx = folderPath.lastIndexOf("\\");
  const folderName = folderPath.slice(lastIndx + 1);
  return folderName;
};

export const getRelativePath = (file) => {
  if (!file.meta?.relativePath) {
    return null;
  }
  const folderPath = file.meta.relativePath.split("\\\\" + file.name)[0];
  return folderPath.replaceAll("\\\\", "/").replace("/", "");
};

const getDetailsBodyRequest = ({ file, uploadId, error = "" }) => {
  const folderName = getFolderNameFromPath(file);
  const body = {
    fileId: file.id,
    uploadId: uploadId,
    name: file.name,
    size: file.size,
    folderId: 0,
    error: error.toString(),
    qqpath:
      folderName?.length > 0
        ? file.meta.relativePath
            .split(file.meta.name)[0]
            .replaceAll("\\\\", "\\")
        : "",
    key: "",
    uuid: "",
    bucket: "",
    etag: "",
  };

  return body;
};

export const beforeUploadAction = async ({
  files,
  uploadId,
  lang,
  userMail,
  totalSize,
  uplaoderStartUpload,
  code,
  isSaved,
  isEmbed,
  isReupload,
  foramtsList = null, // formats list prepared for API to check if the file format is allowed
  embedModalHandler, // in case something wrong with response and its embed uploader
  expireAfter,
}) => {
  const response = await apiRequest(
    "Mails",
    "ReactValidateUploadSizeHomePage",
    {
      authentication: userMail,
      culture: lang,
      filesCount: Object.keys(files).length,
      filesTotalSize: totalSize,
      // JMFORMS
      [isEmbed || isReupload ? "encryptedMailID" : "uploadId"]: uploadId,
      runtime: "FU",
      code: code,
      uploadFormatsList: foramtsList,
      server: "up",
      isSaved: isSaved,
      isReupload,
      expireAfter: expireAfter || 3,
    },
    "POST"
  );

  //added return response to handle error
  if (response.status !== "success") {
    return response;
  }

  const exitCode = response.data?.exitCode?.toLowerCase();

  // JMFORMS
  if (isEmbed) {
    if (exitCode === "uploadconfirmed") {
      uplaoderStartUpload();
    }
    if (
      [
        "maxfileserror",
        "formatserror",
        "masxstorageviolation",
        "maxsizeviolation",
        "maxdeliveriespermonth",
        "error",
      ].includes(exitCode)
    ) {
      embedModalHandler(response.data);
    }
  } else {
    if (
      response.status === "success" &&
      ["uploadcodeconfirmed", "uploadconfirmed"].includes(exitCode)
    ) {
      if (userMail) {
        // save user email in cookie to use it in the next upload in case user is not logged in
        cookies.set("sender-email", userMail);
      }
      uplaoderStartUpload();
    }
  }
};

const handleRedirectToUploadingError = async ({
  mailId,
  langPath,
  message,
}) => {
  await apiRequest(
    "Mails",
    "ReactUpdateMailStatusLog",
    {
      mailId,
      message,
    },
    "POST"
  );
  window.location.href =
    config.baseurl +
    langPath +
    "error/uploading-error?mid=" +
    mailId +
    "&type=react";
};

// detect allowed video duration for current user
export const getAllowedVideoDuration = async (callback) => {
  const res = await apiRequest("Users", "GetVideoDurationLeft");
  if (res.status === "success") {
    callback(+res.data);
  } else {
    callback(0);
  }
};

export const uploadCompleteHandler = async ({
  files,
  uploadId,
  mailId,
  lang,
  userMail,
  token,
  langPath,
  code,
  setItsDone,
  setFinishUpload,
  closeModal,
  reuploadUserSenderEmail,
}) => {
  const totalSize = files.reduce((acc, file) => acc + file.size, 0);
  setItsDone(true);

  // checking if comment was added whith reuploading
  const { commentAdded } = queryString.parse(window.location.search);

  const reuploadBody = {
    reuploadUserSenderEmail: reuploadUserSenderEmail,
    reUploadFileCount: files.length,
    reUploadFilesNames: files.slice(0, 5).map((file) => file.name),
    reuploadComment: !!commentAdded,
  };

  let mailWasReponded = false;

  const response = await apiRequest(
    "Mails",
    "ReactMailUploadCompleteHomePage",
    {
      authentication: userMail,
      culture: lang,
      filesTotalSize: totalSize,
      [setFinishUpload ? "encryptedMailID" : "uploadId"]: !setFinishUpload
        ? uploadId
        : mailId,
      runtime: "FU",
      CSRFToken: token,
      new_uploader: true,
      confirmationCode: code,
      ...reuploadBody,
    },
    "POST"
  );

  if (response) {
    mailWasReponded = true;
    if (response.status === "success") {
      // JMFORMS - if setFinishedUpload exist this logic from JMForms or reupload
      if (
        setFinishUpload &&
        !window.location.pathname.includes("uploading-error")
      ) {
        setFinishUpload({
          reuploadingMailId: mailId,
          newCrfToken: response.data?.csrfToken,
          uploadedFiles: files,
          exitCode: response.data?.exitCode,
        });
        closeModal && closeModal();
        return;
      }

      if (["ok", "SIZE_VALIDATION"].includes(response.data?.exitCode)) {
        const newUrl =
          config.baseurl + langPath + "gallery/" + mailId + "/upload-complete";
        window.location.href = newUrl;
      } else {
        await handleRedirectToUploadingError({
          mailId,
          langPath,
          message: "wrong exist code: " + response.data?.exitCode,
        });
      }
    } else {
      await handleRedirectToUploadingError({
        mailId,
        langPath,
        message: "wron response status: " + response.status,
      });
    }
  }
};

export const createEmptyMail = async ({ uploadId }) => {
  const res = await apiRequest("Mails", "ReactCreateEmptyMail", {
    uploadId: uploadId,
  });
  if (res.status === "error" && res.data === "Error #4201") {
    window.location.href =
      window.location.href.split("home")[0] + "user-blocked";
  }
  return res;
};

export const saveUploadingMailAsSubscriber = async ({ mailId, isUnsave }) => {
  const params = {
    MailId: mailId,
    IsUnsave: isUnsave,
    isCollection: false,
  };
  const response = await apiRequest(
    "mails",
    "ReactSaveMailAsSubscriber",
    params,
    "POST"
  );
  return response;
};

export const handleResetMailStatus = async ({ body, callback }) => {
  const res = await apiRequest(
    "Mails",
    "ReactResetMailUploading",
    body,
    "POST"
  );
  if (res.status === "success") {
    callback();
  } else {
    console.log(res);
  }
  return res;
};
